/**
 * One question per screen (1.5.1, rule 3 of docs/ONE-TAB-ONE-JOB.md): "Question n of N", the question as a heading
 * that takes the focus and is announced when the step changes. The sheet keeps every answer in its own state, so Back
 * never loses what was typed. Book → Tech Support (1.5.0) set the pattern; New activity and Request a volunteer use
 * this.
 */
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAnnounce } from './Announcer';

export function StepHead({ n, of, question, id, testId }: { n: number; of: number; question: string; id: string; testId?: string }) {
  const { t } = useTranslation();
  const announce = useAnnounce();
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    heading.current?.focus();
    announce(t('steps.announce', { n, of, q: question }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [n, question]);
  return (
    <>
      <p className="eyebrow">{t('steps.of', { n, of })}</p>
      <h3 id={id} ref={heading} tabIndex={-1} className="step-q" data-testid={testId}>
        {question}
      </h3>
    </>
  );
}

/** The confirm card: one summary, every answer on its own line. */
export function SummaryCard({ rows, testId, children }: { rows: { label: string; value: React.ReactNode }[]; testId?: string; children?: React.ReactNode }) {
  return (
    <div className="card confirm-card" data-testid={testId}>
      <div className="card-b" style={{ display: 'grid', gap: 6 }}>
        {rows.map((r) => (
          <div key={r.label}>
            <b>{r.label}</b> {r.value}
          </div>
        ))}
        {children}
      </div>
    </div>
  );
}
